export default "__VITE_ASSET__Cl02AH90__"